import { render, staticRenderFns } from "./ReplyEditor.vue?vue&type=template&id=4909ab1a"
import script from "./ReplyEditor.vue?vue&type=script&lang=js"
export * from "./ReplyEditor.vue?vue&type=script&lang=js"
import style0 from "./ReplyEditor.vue?vue&type=style&index=0&id=4909ab1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports